module.exports = __webpack_public_path__ + "static/media/StyleProfile-Preferences.a764e697.svg";